module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/routes/event/event-reports/event-reports.component.scss
// module id = ./src/app/routes/event/event-reports/event-reports.component.scss
// module chunks = 9